import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  let token = null;
  try { token = localStorage.getItem('auth:token'); } catch (e) { void e; }
  const location = useLocation();
  if (!token) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  return children;
}
